module.exports = __webpack_public_path__ + "static/media/权益七@2x.7928a391.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/权益七@2x.png
// module id = 1142
// module chunks = 0